import { put, takeEvery } from 'redux-saga/effects';

import { AUTH_LOGOUT_SAGA } from 'reduxToolkit/actions';
import { logOutSlice, commonSlice } from 'reduxToolkit/reducers';
import { apiCall, apiRoutes, getApiErrorMessage } from 'utils/helpers';

const { logOutStart, logOutSuccess, logOutFailed } = logOutSlice.actions;
const { exceptionHandlerRequest } = commonSlice.actions;

const logOutSaga = function* (): any {
    yield put(logOutStart());
    try {
        const response = yield apiCall({ ...apiRoutes.login });
        if (response.status === 200 && response.data.status) {
            yield put(logOutSuccess(response.data));
        } else {
            const errorData = {
                status: false,
                error: getApiErrorMessage(response),
            };
            yield put(logOutFailed(errorData));
        }
    } catch (error) {
        yield put(exceptionHandlerRequest(error));
    }
};

export const takeLogOutRequest = function* () {
    yield takeEvery(AUTH_LOGOUT_SAGA, logOutSaga);
};
